<template>
  <div class="container-custom">
    <!-- breadcrumbs -->
    <div class="breadscrumbs">
      <a class="breadscrumbs-item active">Product Download</a>
    </div>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>Product Download</h2>
      <v-spacer></v-spacer>
      <button class="btn btn-primary" @click="toProductDownloadCreate">
        <v-icon class="mr-2 white--text">add</v-icon>
        <span>新增檔案</span>
      </button>
    </div>
    <!-- Table -->
    <ProductDownloadTable></ProductDownloadTable>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import ProductDownloadTable from '@/views/C-4__ProductDownload/c/ProductDownloadTable.vue';

export default {
  components: {
    ProductDownloadTable,
  },
  created() {
    this.clear();
    this.getDownloads();
  },
  methods: {
    ...mapActions('productDownload', {
      getDownloads: 'find',
      clear: 'clear',
    }),
    toProductDownloadCreate() {
      this.$router.push({ path: '/product-download/create' });
    },
  },
};
</script>

<style></style>
